import { Injectable } from '@angular/core';
import { ClaimFilterModel } from '../data/models/claim-filter.model';

@Injectable({ providedIn: 'root' })
export class FilterServiceService {
  constructor() {}

  private _filters: { [key: string]: ClaimFilterModel } = {};

  setFilters(filters: ClaimFilterModel, key: string): void {
    this._filters[key] = filters;
    localStorage.setItem(`filters-${key}`, JSON.stringify(filters));
  }

  getFilters(key: string): ClaimFilterModel | null {
    if (this._filters[key]) return this._filters[key];

    const stored = localStorage.getItem(`filters-${key}`);
    return stored ? JSON.parse(stored) : null;
  }

  clear(key: string): void {
    delete this._filters[key];
    localStorage.removeItem(`filters-${key}`);
  }
}
